import React, { useCallback } from 'react';
import {
  BooleanInput,
  Edit,
  ReferenceField,
  SelectInput,
  SimpleForm,
  SimpleShowLayout,
  Tab,
  TabbedShowLayout,
  TextInput,
  required,
  usePermissions,
  useRecordContext,
} from 'react-admin';
import { QRCodeSVG } from 'qrcode.react';
import { ColorInput, CopyToChipboardField, Permission, Permissions } from '../../components';
import { PERMISSIONS } from '../../constants';
import { TagType } from '../../models';
import ImportCpfsDialog from './ImportCpfsDialog';
import TagCustomersTab from './TagCustomersTab';

const TagInviteLink: React.FC<any> = ({ label }) => {
  const outerRecord = useRecordContext();
  if (!outerRecord) return null;
  const { id } = outerRecord;

  const LinkInner = () => {
    const record = useRecordContext();
    if (!record) return null;

    const getTagLink = useCallback(
      () => `https://${record.code}-app.pontuax.com.br/?tagId=${id}`,
      [record],
    );

    return (
      <SimpleShowLayout sx={{ padding: 0 }} record={{ ...record, tagLink: getTagLink() }}>
        <QRCodeSVG value={getTagLink()} bgColor="#ffffff" fgColor="#000000" size={256} />
        <CopyToChipboardField source="tagLink" label={label} showClipButton />
      </SimpleShowLayout>
    );
  };

  return (
    <ReferenceField source="chainId" reference="chains" link={false}>
      <LinkInner />
    </ReferenceField>
  );
};

// `label` só para o Tab não desenhar rótulo vazio em cima do conteúdo.
const TagForm: React.FC<{ label?: false }> = () => (
  <SimpleForm sx={{ maxWidth: 600 }}>
    <TextInput source="name" label="Nome" validate={[required()]} sx={{ minWidth: 300 }} />
    <SelectInput
      label="Tipo"
      source="type"
      choices={TagType.tagTypeChoices}
      validate={[required()]}
      sx={{ minWidth: 300 }}
    />
    {/* cor é obrigatória no backend (Joi.string().required()); sem default o campo vazio mandava 400 */}
    <ColorInput source="color" label="Cor principal" validate={[required()]} defaultValue="#1976d2" />
    <Permission permission={PERMISSIONS.DRAWING}>
      <BooleanInput source="canRedeemLuckyNumber" label="Pode participar de sorteios" defaultValue />
    </Permission>
    <TagInviteLink label="Link de convite" />
    {/* A importação cria pré-cadastro: pede "Cadastrar cliente" OU "Importar CPFs na etiqueta" (igual ao backend). */}
    <Permissions permissions={[PERMISSIONS.CREATE_CUSTOMER, PERMISSIONS.IMPORT_TAG_CPFS]}>
      <ImportCpfsDialog />
    </Permissions>
  </SimpleForm>
);

// Aba Clientes só em etiqueta de cliente e para quem pode ver a lista de clientes (o backend pede as duas permissões).
const TagEditContent = () => {
  const record = useRecordContext();
  const { permissions } = usePermissions();
  if (!record) return null;
  if (record.type !== TagType.client || !permissions?.includes(PERMISSIONS.LIST_CUSTOMER)) return <TagForm />;

  return (
    <TabbedShowLayout>
      <Tab label="Dados">
        <TagForm label={false} />
      </Tab>
      <Tab label="Clientes" path="clientes">
        <TagCustomersTab label={false} />
      </Tab>
    </TabbedShowLayout>
  );
};

const EditTag = (props) => {
  return (
    <Permission permission={PERMISSIONS.TAG}>
      <Edit {...props} title="Editar Etiqueta">
        <TagEditContent />
      </Edit>
    </Permission>
  );
};

export default EditTag;
